import {combineReducers} from 'redux';
import appData from './AppReducer';
import formationData from './FormationsReducer';
import authData from './AuthReducer';
import homeData from './HomeReducer';
import leaguesData from './LeaguesReducer';

export default combineReducers({
    appData,
    formationData,
    authData,
    homeData,
    leaguesData,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js